import { BooleanField, Datagrid, DateField, FunctionField, NumberField, TextField, useTranslate } from 'react-admin'
import InvoiceBulkActionButtons from './InvoiceBulkActionButtons'
import { InvoiceReadModel, } from '../GeneratedClients/FreeBillApi'
import InvoiceStateChip from "./layout/components/InvoiceStateChip"
import InvoiceChildrenList from '../invoiceCorrelations/InvoiceChildrenList'

const InvoiceDatagrid = ({userId}: {userId: string}) => {
  const translate = useTranslate()

  return (
    <Datagrid
      rowClick='show'
      bulkActionButtons={<InvoiceBulkActionButtons userId={userId} />}
      isRowExpandable={(row: InvoiceReadModel) => row.isCanceled || row.reminderStepNumber !== null}
      expand={<InvoiceChildrenList />}
    >
      <TextField source="invoiceNumber" label="resources.invoices.invoiceNumber" sortable={false} />
      <TextField label="resources.company.companyName" sortable={false} source="invoiceRecipient.company.companyName" />
      <FunctionField textAlign="right" label="resources.invoices.grossAmount" render={(invoice: InvoiceReadModel) => (
        <NumberField sx={{textDecoration : invoice.isCanceled ? "line-through" : "none"}} source="grossAmount" options={{ style: 'currency', currency: 'EUR' }} sortable={false} />
      )}/>
      <FunctionField label='resources.invoices.invoiceState' render={(invoice: InvoiceReadModel) => <InvoiceStateChip invoice={invoice} size="small" />} />
      <DateField source="invoiceDate" label='resources.invoices.invoiceDate' sortable={false} />
      <DateField source="dueDate" label='resources.invoices.dueDate' sortable={false} />
      <BooleanField source="isSendByMail" label='resources.invoices.isSendByMail' sortable={false} />
      <FunctionField 
        label='resources.invoices.isBooked' 
        sortable={false} 
        render={(invoice: InvoiceReadModel) => <BooleanField record={{isBooked: invoice.bookingInfos !== null}} source="isBooked" />}
      />
      <NumberField label={translate("resources.invoices.comment", {smart_count: 2})} source="comments.length" emptyText="0" sortable={false} />
    </Datagrid>
  )
}

export default InvoiceDatagrid